import React from "react";
import { Text, SettingsSelector, FrameIcon } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";
import { withAppState } from "../../../state";
import { TextDisclaimerStyled } from "../styles/Styled";
import { isAccessAllowedByParentalLevel } from "../../../services/parentalControlService";
import { ParentalWrapper } from "../../Settings/styles/Styled";
import { resolution } from "./SettingConfig";

export const ParentalControl = withAppState(
  ({ parentalControlList, onItemSelected, applicationState: { parentalLevel } }) => {
    return (
      <ParentalWrapper>
        <FrameIcon name="newParentalControl" className="fixMargin"/>
        <Text rank="1" text={i18n.get(`pages.settings.menu.parentalControl`)} size="xmedium" />
        <SettingsSelector
          items={parentalControlList.map(item => ({
            key: item,
            title: i18n.get(`pages.settings.parentalControl.level.${item}`),
            description: i18n.get(`pages.settings.parentalControl.description.${item}`),
            active: item === parentalLevel
          }))}
          onItemSelected={onItemSelected}
          selectedIndex={parentalControlList.findIndex(item => item === parentalLevel)}
          titleFontSize={resolution?.parentalControl.title.FontSize}
          titleColor={resolution.parentalControl.title.Color}
          descriptionFontSize={resolution.parentalControl.description.FontSize}
          descriptionColor={resolution.parentalControl.description.Color}
          isFromParentalControl={true}
        />
        {!isAccessAllowedByParentalLevel() && (
          <TextDisclaimerStyled size={"small"} text={i18n.get("pages.settings.parentalControl.restricted")} type="primary" className="restricted" />
        )}
      </ParentalWrapper>
    );
  }
);
